import { appBottombar, appTopbar } from '@styles/theme'
import styled from '@emotion/styled/macro'

export const MapContainer = styled.div`
  position: fixed;
  top: ${appTopbar};
  bottom: ${appBottombar};

  height: calc(100svh - (${appTopbar} + ${appBottombar}));
  width: 100svw;
  
  cursor: pointer;
  overflow-x: scroll;
`